


















































































import { FactureFournisseur } from "../../models/FactureFournisseur";
import { ContactApi } from "../../api/ContactApi";
import { Contact } from "../../models/Contact";
import moment from "moment";
import NumeralInput from "../../core/Forms/NumeraInput.vue";
import TextInput from "../../core/Forms/TextInput.vue";
import TextareaInput from "../../core/Forms/TextareaInput.vue";
import ContactSelect from "../../core/Forms/ContactSelect.vue";

export default {
    name: "FactureFournisseurModalEdit",
    components: { ContactSelect, TextareaInput, TextInput, NumeralInput },
    props: {
        factureFournisseur: FactureFournisseur,
    },
    data() {
        return {
            invoiceDate: null,
            dueDate: null,
            ContactApi: new ContactApi(),
            contactSelectFilters: [Contact.EType.Fournisseur],
        };
    },
    created() {
        this.initDates();
    },
    methods: {
        initDates() {
            if (this.factureFournisseur.invoice_date) {
                this.invoiceDate = new Date(
                    this.factureFournisseur.invoice_date
                );
            }
            if (this.factureFournisseur.due_date) {
                this.dueDate = new Date(this.factureFournisseur.due_date);
            }
        },
        updateInvoiceDate(date) {
            this.factureFournisseur.invoice_date =
                moment(date).format("YYYY-MM-DD");
        },
        updateDueDate(date) {
            this.factureFournisseur.due_date =
                moment(date).format("YYYY-MM-DD");
        },
    },
    watch: {
        factureFournisseur: {
            immediate: true,
            handler() {
                this.initDates();
            },
        },
    },
};
